<template>
    <div class="auth-box">
        <base-header></base-header>
        <h1 v-if="type == 1">加载中…</h1>
        <base-button v-else :name="`微信授权一键登录`" class="auth-btn" @click="get_auth()"></base-button>
    </div>
</template>
<script>
import { baseUrls } from '@/utils/baseUrlConfig'
const base_url = baseUrls.user_url
export default {
    name: 'auth',
    data() {
        return {
            type: 1, //1加载中  2授权按钮
            fromPage: this.$route.query.fromPage,
        }
    },

    created() {
        if (this.$route.query.openid) {
            this.$storage.setOpenId(this.$route.query.openid)
            this.$storage.setmKey(this.$route.query.m_key)
            this.getwxBindByOpenid()
        } else {
            // 未授权
            // console.log('跳转到授权页');
            this.get_auth()
        }
    },
    methods: {
        // 查询是否绑定微信
        getwxBindByOpenid() {
            this.$http.getwxBindByOpenid(this.$storage.getOpenId(), true).then((res) => {
                if (res.code == 0) {
                    //未绑定
                    if (this.fromPage && this.fromPage != '') {
                        this.$router.push({ path: '/login', query: { fromPage: this.fromPage } })
                    } else {
                        this.$router.push('/login')
                    }
                } else {
                    this.userLogin()
                }
            })
        },
        // openid免密登录
        userLogin() {
            this.$http.userOpenidLogin(this.$storage.getOpenId(), this.$storage.getmKey(), true).then((res) => {
                if (res.code == 0) {
                    //登录成功
                    this.$storage.setAuth(res.token)
                    this.$storage.setToken(res.token)
                    if (this.fromPage && this.fromPage != '') {
                        if(this.fromPage.indexOf('http') > -1){
                            // 外部地址
                            window.location.replace(this.$common.setUrlQuery({url: decodeURIComponent(this.fromPage), query:{token: res.token}}));
                            // window.location.replace(decodeURIComponent(this.fromPage) + '?token=' + (res ?  : null));
                        } else if(this.fromPage.indexOf('heroEvo') > -1){
                            // 英雄进化3.0切换账号
                            if(this.$common.isIos() == 1){
                                this.$router.push({ path: '/hero_evo', query: { fromPage: 'https://go.09game.com/?id=177' } })
                            } else {
                                this.$router.push({ path: '/hero_evo', query: { fromPage: 'https://go.09game.com/?id=176' } })
                            }
                        } else{
                            this.$router.push(this.fromPage)
                        }
                    } else {
                        this.$router.push('/')
                    }
                } else {
                    this.$message.error(res.err ? res.err : res.msg ? res.msg : '登录失败')
                }
            })
        },
        get_auth() {
            if (this.fromPage && this.fromPage != '') {
                window.location.replace(base_url + '/GetWxOpenid?fromPage=' + this.fromPage)
            } else {
                window.location.replace(base_url + '/GetWxOpenid')
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.auth-box {
    .auth-btn {
        margin-top: 0.6rem;
    }
    h1 {
        color: #c39b5e;
        font-size: 0.62rem;
        font-weight: bold;
        height: 1rem;
        line-height: 1rem;
        text-align: center;
    }
}
</style>




// WEBPACK FOOTER //
// src/view/auth_page.vue